import * as React from 'react';
import { styled, useTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Stack';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { v4 as uuidv4 } from 'uuid';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import { SmallScreenContext } from '../Bs4Theme/Bs4UxTemplates';
import Bs4Dialog from '../Bs4Components/Bs4Dialog'
import Bs4I18N from '../Bs4I18N';

export default function Bs4SearchEngine(props) {
  const smallScreen = React.useContext(SmallScreenContext);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false)

  const handleClick = (event) => {
    setOpen(!open);
  }

  const handleClose = (event) => {    
    setOpen(false);
  }

  if (!Array.isArray(props.searcc) || props.searcc.length < 1) return null;
  
  return (
    <Stack direction='row'>
      <IconButton onClick={handleClick}>
        {/* <i className="fa-solid fa-magnifying-glass"/> */}
        <SearchIcon/>
      </IconButton>
      <ThemeProvider theme={props.mainTheme}>
        <Bs4Dialog
          keepMounted
          bs4BackgroundColor={theme.Bs4.backgroundColor}
          fullWidth
          open={open} 
          onClose={handleClose}
          sx={{
            touchAction: 'none',
            '& .MuiDialog-container': {
              alignItems: 'flex-start',
            },
          }}        
          slotProps={{
            PaperProps: {sx: {
              backgroundColor: theme.Bs4.backgroundColor,
            }}
          }}
        >
          <DialogTitle >
            <Stack direction="row" spacing={2} sx={{justifyContent: "space-between", alignItems: "flex-start", }}>
              {/* <i className="fa-solid fa-magnifying-glass"/> */}
              <SearchIcon/>
              <IconButton onClick={handleClose}>
                <CloseIcon/>
                {/* <i className="fa-solid fa-xmark"/> */}
              </IconButton>
            </Stack>
          </DialogTitle>                
          <DialogContent>
            <Bs4SearchEnginePlane {...props} onClose={handleClose} open={open}/>
          </DialogContent>          
        </Bs4Dialog>
      </ThemeProvider>
    </Stack>
  );
}

const Bs4SearchEnginePlane = (props) => {
  const searchEngineArray = React.useMemo(() => {
    const sea = (props.searcc || []).map(searchEngine => {
      searchEngine.id = searchEngine.id || uuidv4();
      return searchEngine;
    });    
    return sea;
  }, [props.searcc]);

  const [searchEngine, setSearchEngine] = React.useState(searchEngineArray[0] || null);
  const [options, setOptions] = React.useState([]);
  const [value, setValue] = React.useState(''); 
  const [inputValue, setInputValue] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const inputRef = React.useRef(null);
  const searchInTT = Bs4I18N.useTT('Search in', 'Szukaj w', 'Bs4SearchEnginePlane');  
  
  const handleChangeSearchEngine = (event, newSearchEngine) => {    
    if (searchEngine != newSearchEngine) setOptions([]);
    setSearchEngine(newSearchEngine);
  }  

  React.useEffect(() => {    
    getData();
  }, [inputValue, searchEngine]);

  React.useEffect(() => {
    if (!props.open) setInputValue('');
  }, [props.open]);

  const getData = () => {
    if (!inputValue || inputValue.length < 3) {
      setOptions([]);
      return;
    }
    
    const url = Bs4MainDispatch.getUrlPath('web.php');
    const [seUrl, seQuery] = searchEngine?.url?.split('?') || [null, null];
    if (!seQuery) return;
    const queryUrl = new URLSearchParams(seQuery);
    queryUrl.append('_dc', Date.now());
    queryUrl.append('query', inputValue);
    queryUrl.append('page', 1);
    queryUrl.append('start', 0);
    queryUrl.append('limit', 25);    

    setLoading(true)
    fetch(url+'?'+queryUrl.toString())
    .then(response => {
      return response.text();
    })
    .then(returnedText => {
      setLoading(false)
      try {
        setOptions([...JSON.parse(returnedText).messgs.data]);
      } catch (e) {
        console.error(e);
        console.log(returnedText);
      }
    })
    .catch((error) => {
      console.log(error);
      setLoading(false)
    });
  }

  React.useEffect(() => {
    if (inputRef.current && props.open) inputRef.current.focus();  
  }, [inputRef.current, props.open, setValue]);  

  const variant = null;//{variant: 'outlined'};

  if (searchEngineArray.length === 0) return null;

  // console.log('...???...OPEN ENGINE !!!', props.open, value, inputValue)

  return (
    <Stack direction="column" spacing={2} sx={{justifyContent: "flex-start", alignItems: "flex-start",}}>
      <Autocomplete
        fullWidth        
        disableClearable
        value={searchEngine}
        onChange={handleChangeSearchEngine}
        options={searchEngineArray}
        getOptionLabel={(option) => option.text}
        sx={{padding: 1}}
        renderInput={(params) => <TextField {...params} label={searchInTT} {...variant}/>}
      />
      <Autocomplete
        fullWidth        
        value={value}
        onChange={(event, newValue) => {
          setValue(null);
          setInputValue(inputValue);
          Bs4MainDispatch.commandParserAfter(Bs4Kartoteka.firstBs4KartotekaId)
          props.onClose();
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        open={props.open && options.length > 0}
        //clearOnBlur={false} //20225-04-01 //20225-04-09 to nie działa
        freeSolo
        options={options}
        loading={loading}
        getOptionLabel={option => option?.name || ''}
        popupIcon={null}
        sx={{padding: 1}}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}        
        filterOptions={(option, state) => option}
        renderInput={(params) => <TextField inputRef={inputRef} {...params} {...variant}/>}
        renderOption={(props, option) => (
          <li {...props} key={option.id} dangerouslySetInnerHTML={{__html: option.name}} style={{alignItems: 'flex-start'}}/>
        )}
      />
    </Stack>
  );
}